import React from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
} from "@mui/material";
import { EditorPhrase } from "../../api/phrasebook_editor";
import FormattedText from "../common/formatted-text";

interface PhraseDeleteDialogProps {
  open: boolean;
  phrase: EditorPhrase | null;
  onClose: () => void;
  onConfirm: () => void;
}

const PhraseDeleteDialog: React.FC<PhraseDeleteDialogProps> = ({
  open,
  phrase,
  onClose,
  onConfirm,
}) => {
  return (
    <Dialog open={open} onClose={onClose}>
      <DialogTitle>Confirm Delete</DialogTitle>
      <DialogContent>
        <Typography>
          Are you sure you want to delete the phrase "<FormattedText text={phrase?.phrase || ""} />"?
        </Typography>
        <Typography variant="body2" color="text.secondary" sx={{ mt: 1 }}>
          This action cannot be undone.
        </Typography>
      </DialogContent>
      <DialogActions sx={{ pb: 2, pr: 3 }}>
        <Button onClick={onClose}>Cancel</Button>
        <Button onClick={onConfirm} color="error" variant="contained">
          Delete
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default PhraseDeleteDialog;